module.exports = __webpack_public_path__ + "static/media/u1F623.f7c1ab85.webp";